<template>
  <div id="app">
    <notifications group="notificacion_principal"></notifications>

    <span class="text-left">
      <MonitorRed></MonitorRed>
    </span>
    <vue-page-transition name="flip-x">
      <router-view />
    </vue-page-transition>

    <!-- popup de expiracion de sesion -->

    <div
      id="popup_expiracion_sesion"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-success" style="border: dashed 3px white">
          <div class="modal-header">
            <h5 class="modal-title">
              <p id="id_header_popup_expiracion_sesion"></p>
            </h5>
            <button              
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p id="id_header_popup_expiracion_sesion"></p>
            <div class="row ">
                <div class="col">
                  <img 
                    class="img-fluid rounded-circle"
                    style="width:200px; "
                  src="https://res.cloudinary.com/dnw28mjhi/image/upload/v1718809627/MagicResources/348236459_200537386139685_8779607601510244742_n_dhphyz.png"/>
                </div>
            </div>    
            <div class="row">
              <div class="col">
                <p id="id_mensaje_popup_expiracion_sesion" style="visible:false" />
                <p class="h3 text-white">Al parecer no tienes sesión </p>
              </div>              
            </div>
            <div class="row">
                <div class="col">
                  <button type="button" class="btn btn-link text-white" v-on:click="signout()">
                    <p v-on:click="signout()" class="h2 text-white"><i class="fa fa-hand-point-right"></i> Pulsa aquí para iniciar sesión</p>
                  </button>
                </div>
            </div>

            <!--<div class="row">
              <div class="cotainer">
                <div class="row justify-content-center">
                  <div class="col-5 text-center">
                    <i id="id_icono_popup_expiracion_sesion"></i>
                  </div>
                  <div class="col text-left">
                    <h2>
                      <p id="id_mensaje_popup_expiracion_sesion" />
                    </h2>                    
                    <button type="button" class="btn btn-link" v-on:click="signout()">
                      <p v-on:click="signout()">Click aquí para iniciar sesión</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>-->
          </div>
          <!--<div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cerrar
            </button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "./controller/Popup";
import MonitorRed from "./componentes_generales/MonitorRed";
import { usuarioSesion, clearSesion } from "./helpers/Sesion";

export default {
  components: {
    Popup,
    MonitorRed,
  },
  name: "App",
  methods: {
    signout() {
      console.log("Signout ");
      //this.$session.clear();
      clearSesion();
      $("#popup_expiracion_sesion").modal("hide");
      this.$router.push("/");
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50; */
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue